export default __webpack_public_path__ + "static/media/Shadow's Boots of the Dusk Rebellion.15159bb5.jpg";